import React, { Component, Suspense } from 'react'
import Modal from '.'
import PopupModal from './PopupModal'
import { connect } from 'react-redux'
import { getNominative } from '../../common/utils'
import Field from '../fields'
import { history } from '../../store'
// @ts-ignore
import { showToastFunction } from './types' // Add correct type for showToastFunction
// @ts-ignore
import { RouteComponentProps } from 'react-router-dom'

interface CarePlanModalProps extends RouteComponentProps {
  createItem: (data: {
    json: any
    onComplete: (resp: any) => void
    url: string
  }) => void
  fields: any // Define the type for 'fields'
  resident: any // Define the type for 'resident'
  showToast: showToastFunction // Define the type for 'showToast'
  isOpen: boolean
  carePlanNominative: string // Define the type for 'carePlanNominative'
}

class CarePlanModal extends Component<CarePlanModalProps> {
  handleSubmit = () => {
    const { createItem, fields, resident, showToast } = this.props

    createItem({
      json: {
        ...fields,
        resident,
        isCustom: true,
      },
      onComplete: (resp) => {
        showToast({ title: 'Added a custom Care Plan' })
        history.push(`/residents/${resident}/care-plans/${resp.id}`)
      },
      url: `list/care-plans`,
    })
  }

  render() {
    const { fields, isOpen, carePlanNominative, ...formProps } = this.props

    if (!isOpen) return null

    return (
      <PopupModal
        confirmText="Add"
        buttonIcon="plus"
        buttonColour="success"
        list={getNominative(carePlanNominative, 'Care Plan')}
        onConfirm={this.handleSubmit}
        {...formProps}
        type="create"
      >
        <div style={{ marginBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="customName"
            label="Title"
            required
            note={getNote(carePlanNominative)}
            type="text"
            values={fields}
          />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const MODAL_ID = 'addCarePlan'

const getNote = (carePlanNominative: string) =>
  `Create a blank ${getNominative(
    carePlanNominative,
    'Care Plan'
  )}. You will not be able to delete this ${getNominative(
    carePlanNominative,
    'Care Plan'
  )} once it has been added, but you can archive it if it is not needed anymore.`

const mapStateToProps = (state: any) => ({
  carePlanNominative: state.global.home.preferredCarePlansNominative,
})

const wrappedModal = connect(mapStateToProps, null)(CarePlanModal)

export default Modal(wrappedModal, MODAL_ID)
